import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MergeDataset} from "../models/merge-dataset";
import {MergeJobInfo} from "../models/merge-job-info";
import {DatasetApiService} from "../generated-sources/api/dataset";

@Injectable({
    providedIn: "root"
})
export class DatasetService {
    private readonly datasetService = inject(DatasetApiService);

    public getDatasets(): Observable<string[]> {
        return this.datasetService.getDatasets();
    }

    public deleteDataset(datasetToDelete: string): Observable<string> {
        return this.datasetService.deleteDataset(datasetToDelete);
    }

    public mergeDatasets(mergeDataset: MergeDataset): Observable<number> {
        return this.datasetService.mergeDatasets(mergeDataset);
    }

    public clearMergeTargets(dataset: string): Observable<string> {
        return this.datasetService.clearMergeTargets(dataset);
    }

    public getMergeTargets(): Observable<MergeDataset[]> {
        return this.datasetService.getMergeTargets();
    }

    public setMergeTarget(mergeTarget: MergeDataset): Observable<string> {
        return this.datasetService.setMergeTarget(mergeTarget);
    }

    public getAllMergeJobs(): Observable<MergeJobInfo[]> {
        return this.datasetService.getAllMergeJobs();
    }
}
